let ENV = {
  api: 'https://backend.groupify.ch/api/',
  //http://localhost:5000/api/
};

export default ENV;
